import { Box, Grid } from "@mui/material";
import { setSearchActive } from "components/app/App.slice";
import Plans from "components/common/plans/plans.layout";
import { fetchPlansAsync } from "components/common/plans/plans.slice";
import SearchAndFilterRow from "components/common/SearchAndFilterRow";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { allPlansType, missingIncodeText, PAGE_SIZE } from "utils/CommonConstants";
import { pageNames } from "utils/Types";

function ActionPlans() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const searchText = searchParams.get("q") as string;
  const dispatch = useAppDispatch();

  const plansList: any = useAppSelector((state) => state.plans.list);
  const totalRecords: any = useAppSelector((state) => state.plans.totalRecords);
  const isLoading = useAppSelector((state) => state.plans.status);
  const [pageNo, setPageNo] = useState(1);
  const localSearch = useAppSelector((state) => state.app.searchText);
  const filterIds = useAppSelector((state: any) => state.app.filterIds);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedFunctionalAreas = useAppSelector((state: any) => state.app.selectedFunctionalAreas);
  const selectedPlanType = useAppSelector((state: any) => state.app.selectedPlanType);

  const getProps = (page?: number) => {
    if (isEmpty(searchText || localSearch)) dispatch(setSearchActive(false));
    return {
      filter: {
        innCode,
        functionalAreaIds: id ? [id] : selectedFunctionalAreas,
        filterIds
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: searchText || localSearch,
      planType: selectedPlanType?.length > 0 ? selectedPlanType : [allPlansType],
      isSortingDisabled: true
    };
  };

  useEffect(() => {
    const props: any = getProps(1);
    if (searchText || localSearch) props.sort = { property: "relevance", direction: "ASC" };
    if (innCode !== missingIncodeText) {
      dispatch(fetchPlansAsync(props));
      setPageNo(1);
    }
  }, [dispatch, id, innCode, filterIds, searchText, localSearch, selectedPlanType]);

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <>
      <Box>
        <Grid container justifyContent="space-between"></Grid>
        <Grid item md={12}>
          <SearchAndFilterRow id={id} searchText={searchText} inputText={localSearch} />
          <Plans
            pageName={pageNames.functionalArea}
            plansList={plansList}
            isLoading={isLoading}
            totalList={totalRecords}
            loadMore={fetchMore}
          ></Plans>
        </Grid>
      </Box>
    </>
  );
}

export default ActionPlans;
